module.exports = __webpack_public_path__ + "img/user-f-grey.d50861b.svg";